module.exports = __webpack_public_path__ + "img/2019全国公.56b0c929.jpg";